import { Formik } from 'formik'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import { Select } from '@/components/Form'

import ViewByFilterMap from './ViewByFilterMap'

function AnalyticsFilters(props: any) {
  const intl = useIntl()

  const onUpdateViewBy = (id: any, element: any) => {
    const type = ViewByFilterMap.getType(element.target.value)
    const rangeItem = ViewByFilterMap.getViewByRangeItem(element.target.value)
    if (ViewByFilterMap.VIEW_BY_TYPES.RELATIVE === type) {
      const params = {
        [id]: element.target.value,
        // @ts-expect-error
        key: rangeItem.key,
        rangeFilter: element.target.value,
        latest: moment(new Date()).toISOString(),
        // @ts-expect-error
        oldest: rangeItem.oldest(),
        // @ts-expect-error
        interval: rangeItem.interval,
        // @ts-expect-error
        chartFormat: rangeItem.chartFormat,
        // @ts-expect-error
        difference: rangeItem.difference
      }

      props.onChangeAnalyticsViewBy({ filterParams: params, isDateRangeQuery: false, displayFilterOverlay: false })
    } else if (ViewByFilterMap.VIEW_BY_TYPES.CUSTOM_DATE === type) {
      props.onChangeAnalyticsViewBy({
        // @ts-expect-error
        filterParams: { key: rangeItem.key, chartFormat: 'MMM Do' },
        displayFilterOverlay: true
      })
    }
  }

  const buildViewByRangeOptions = () => {
    return ViewByFilterMap.VIEW_BY_FILTER_MAP.map(item => {
      return {
        key: item.key,
        value: item.value,
        label: intl.formatMessage(item.labelId)
      }
    })
  }

  const getDefaultOptionFromProps = (defaultOption: any, range: any) => {
    return range.find((item: any) => {
      return props.defaultOption === item.key
    })
  }

  const viewByRangeOptions = buildViewByRangeOptions()
  const { defaultOption } = props
  const defaultViewByOption = getDefaultOptionFromProps(defaultOption, viewByRangeOptions).value
  return (
    <div className="filters">
      {/* @ts-expect-error */}
      <Formik
        enableReinitialize={true}
        initialValues={{
          viewByRangeSelect: defaultViewByOption || ''
        }}
      >
        <Select name="viewByRangeSelect" onChange={onUpdateViewBy.bind(null, 'viewByRangeSelect')}>
          {viewByRangeOptions.map(viewByOption => {
            return (
              <Select.Option key={viewByOption.key} value={viewByOption.value}>
                {viewByOption.label}
              </Select.Option>
            )
          })}
        </Select>
      </Formik>
    </div>
  )
}

AnalyticsFilters.displayName = 'SpaceAnalyticsRelativeDateFilters'

AnalyticsFilters.propTypes = {
  onChangeAnalyticsViewBy: PropTypes.func.isRequired,
  onClearDateFilters: PropTypes.func.isRequired,
  defaultOption: PropTypes.string.isRequired,
  dateFilterParams: PropTypes.object.isRequired
}

export default AnalyticsFilters
